var map = {
	"./eduConfig": 18661,
	"./gsConfig": 45420,
	"./innovationConfig": 30537,
	"./innovationDevConfig": 99133,
	"./jitsiConfig": 92192,
	"./mateConfig": 25710,
	"./mertiConfig": 57245,
	"./sensteeConfig": 41091,
	"./tubeConfig": 1425,
	"./yogaConfig": 41182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14586;